import { environmentConfiguration } from '@src/config/env';

const { dev } = environmentConfiguration;

const loglevel = dev ? 'debug' : 'error';

export const loglevelConfiguration = {
    loglevel,
};
